<template>
    <div class="campaign-option campaign-adset-location">
        <div class="campaign-option--title">
            <slot name="title"></slot>
        </div>

        <div class="campaign-adset-location__input">
            <multiselect v-model="model"
                         :options="options"
                         label="label"
                         track-by="id"
                         :multiple="multiple"
                         :searchable="searchable"
                         :show-labels="false"
                         :allow-empty="allowEmpty"
                         :hide-selected="multiple"
                         :placeholder="placeholder"
                         :disabled="disabled"
            >
            </multiselect>
        </div>
    </div>
</template>

<script type="text/babel">
    import Multiselect from 'vue-multiselect'

    export default {
        props: {
            value: {
                type: [Array, Object],
                default: 'value'
            },
            options: {
                type: Array
            },
            multiple: {
                type: Boolean,
                default: false
            },
            searchable: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: 'Select'
            },
            allowEmpty: {
                type: Boolean,
                default: true
            },
            disabled: {
              type: Boolean,
              default: false
            }
        },

        data() {
            return {
                model: this.value
            }
        },

        watch: {
            value(val) {
                this.model = val;
            },
            model() {
                this.$emit('input', this.model);
            }
        },

        components: {
            Multiselect
        }
    }
</script>
